// extracted by mini-css-extract-plugin
export default {"none":"UserDrop_none__wZImg","userDrop":"UserDrop_userDrop__qlu0a","username":"UserDrop_username__H4GIx","person":"UserDrop_person__GM7hB","list":"UserDrop_list__at5sa"};